<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group" v-if="rightsProfile.length != '0' && entityType != 1">
            <label for="id-account">
              {{ $t('common.routing.account_id') }}<span class="color-red"> * </span>
            </label>
            <select class="form-control" id="id-account" v-model="IdAccountSelected" :disabled="mode === 'details' && editMode === false">
              <option :value="account.idAccount" selected v-for="account in rightsProfile" :key="account.idAccount"> {{ account.accountName }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group" v-if="rightsProfile.length != '0'">
          </b-col>
        </b-row>
        <b-row>
  <!--        <b-col sm="6" class="form-group">-->
  <!--          <form-write-group-label-input v-model="message" isMandatory :disabled="mode === 'details' && editMode === false"-->
  <!--            :inputLabel="$t('common.routing.message')" :placeholderValue="$t('common.routing.message')">-->
  <!--          </form-write-group-label-input>-->
  <!--        </b-col>-->
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="routingName" isMandatory :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.routing_name_'+entitiesType)" :placeholderValue="$t('common.routing.routing_name_'+entitiesType)">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="routingDescription" :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.routing_description_'+entitiesType)" :placeholderValue="$t('common.routing.routing_description_'+entitiesType)">
            </form-write-group-label-input>
          </b-col>

  <!--        <b-col sm="6" class="form-group" v-if="false">-->
  <!--          <label>-->
  <!--            {{ $t('common.routing.receiver_type') }}<span class="color-red"> * </span>-->
  <!--          </label>-->
  <!--          <select class="form-control" v-model="receiverType" readonly :class="selectTypeColor" :disabled="mode === 'details' && editMode === false">-->
  <!--&lt;!&ndash;            <option value="" hidden disabled> {{ $t('common.routing.select_receiver_type') }} </option>&ndash;&gt;-->
  <!--            <option value="0" class="color-black-message-details" > {{ $t('common.routing.bic') }} </option>-->
  <!--            <option value="1" class="color-black-message-details" > {{ $t('common.routing.bic_group') }} </option>-->
  <!--          </select>-->
  <!--        </b-col>-->
  <!--        <b-col sm="6" v-if="receiverType == ''"></b-col>-->
          <b-col sm="6" class="form-group" v-if="receiverType == 0">
            <form-write-group-label-input v-if="entitiesType == 'responder'" v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id_responder')" :placeholderValue="$t('common.routing.receiver_id_responder')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else-if="entitiesType == 'requester'" v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id_requester')" :placeholderValue="$t('common.routing.receiver_id_requester')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else-if="entitiesType == 'rvm'" v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id_rvm')" :placeholderValue="$t('common.routing.receiver_id_rvm')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else-if="entitiesType == 'decentralised'" v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id_responder_decentralised')" :placeholderValue="$t('common.routing.receiver_id_responder_decentralised')">
            </form-write-group-label-input>
            <form-write-group-label-input v-else v-model="receiverId" isMandatory :disabled="mode === 'details' && editMode === false"
              :inputLabel="$t('common.routing.receiver_id')" :placeholderValue="$t('common.routing.receiver_id')">
            </form-write-group-label-input>
          </b-col>

          <b-col sm="6" class="form-group" v-if="receiverType == 0 && entitiesType == 'decentralised'">
            <form-write-group-label-input v-model="memberId" :disabled="mode === 'details' && editMode === false"
                                          :inputLabel="$t('common.routing.member_id')" :placeholderValue="$t('common.routing.member_id')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" v-if="entityType != 1"></b-col>


          <b-col cols="6" class="form-group" v-else>
            <label>{{ $t('common.global.corporate_identifier_type') }}</label>

            <a id="emailGrp-picker-link" class="filter-item-content d-flex justify-content-between p-1 pt-2" href="#" style="max-width:calc(100% - 30px)">
              <span :class="{'filter-item-input-complete':statusDisplay.nb > 0}">{{ statusDisplay.label }}</span>
              <i class="fa-light fa-chevron-down" size="17px" id="emailGrp-chevron"></i>
            </a>

            <b-popover target="emailGrp-picker-link"
                      :title="$t('common.select_corporate_identifier_type')"
                      triggers="focus"
                       :disabled="mode === 'details' && editMode === false"
                       placement="bottom">
            <span v-for="status in corporateIdentifierType" :key="status.name">
                <b-form-checkbox
                    v-model="status.state"
                    :value="1"
                    :unchecked-value="0">
                  <span>{{ status.label }}</span>
                </b-form-checkbox>
            </span>
            </b-popover>
          </b-col>
          <b-col sm="6" class="form-group" v-if="entitiesType == 'decentralised'">
          </b-col>
          <b-col sm="6" class="form-group" v-if="entitiesType == 'decentralised'">
            <label for="slider-seuil" class="col-form-label">{{ $t('common.routing.acceptable_error_threshold') }}<span class="color-red"> * </span></label>
            <div class="" style="text-align: right;">{{acceptableErrorThreshold}}</div>
            <input :disabled="mode === 'details' && editMode === false" readonly class="range-slider-streammind" :class="sliderColorClass" type="range" min="1" max="101" id="slider-seuil" v-model="acceptableErrorThreshold">
          </b-col>
  <!--        <b-col sm="6" class="form-group" v-else-if="receiverType == 1">-->
  <!--          <label>-->
  <!--            {{ $t('common.routing.bic_group') }}<span class="color-red"> * </span>-->
  <!--          </label>-->
  <!--          <select class="form-control" v-model="IdBICGroup" readonly :class="selectTypeColor" :disabled="mode === 'details' && editMode === false">-->
  <!--            <option value="" hidden disabled> {{ $t('common.routing.select_bic_group') }} </option>-->
  <!--            <option v-for="bic in bicGroupList" :key="bic" :value="bic.IdBicGroup" class="color-black-message-details" > {{ bic.GroupName }} </option>-->
  <!--          </select>-->
  <!--        </b-col>-->
  <!--        <b-col sm="6" v-if="entitiesType == 'rvm'" class="form-group">-->
  <!--          <label>-->
  <!--            {{ $t('common.routing.role') }}<span class="color-red"> * </span>-->
  <!--          </label>-->
  <!--          <select class="form-control" v-model="roleSelected" readonly :class="selectTypeColor" :disabled="mode === 'details' && editMode === false">-->
  <!--            <option value="null" hidden disabled> {{ $t('common.routing.select_config_role') }} </option>-->
  <!--            <option value="0" class="color-black-message-details" > {{ $t('common.routing.role_0') }} </option>-->
  <!--            <option value="1" class="color-black-message-details" > {{ $t('common.routing.role_1') }} </option>-->
  <!--          </select>-->
  <!--        </b-col>-->
          <b-col sm="12">
            <form-accordion :title="$t('common.routing.connector')" :isTitleUpperCase="false" v-if="(entitiesType != 'decentralised')">
  <!--            <button v-if="(editMode|| mode == 'create')" class="btn w-auto px-4 btn-tertiary mb-5" @click="addCertificat">{{ $t('common.security.add_certificat') }}</button>-->
              <b-row v-for="(config, key) in arrayConfig" :key="key">
                <b-col sm="6" class="form-group" v-if="((key == '0' && entityType != '2') || (key == '1' && entityType != '0'))">
                  <label v-if="(key == '0' && entityType == '0') || (key == '1' && entityType == '2')" for="config-type">
                    {{ $t('common.routing.config_type_connector') }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <label v-else for="config-type">
                    {{ $t('common.routing.config_type_'+key) }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <select class="form-control" v-model="config.configType" @change="resetConfig(config)" readonly
                    id="config-type"
                    :class="selectTypeColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" hidden disabled> {{ $t('common.routing.select_config_type') }} </option>
                    <option value="NULL" v-if="entitiesType == 'rvm' && key == 0" class="color-black-message-details"> {{ $t('common.routing.none') }} </option>
                    <!--            <option value="INTERPROCESS" class="color-black-message-details" > {{ $t('common.routing.inter_process') }} </option>-->
                    <option value="MQSERIES" v-if="entitiesType != 'decentralised'" class="color-black-message-details" > {{ $t('common.routing.mqseries') }} </option>
                    <!--            <option value="REMOTEFOLDER" class="color-black-message-details" > {{ $t('common.routing.remote_folder') }} </option>-->
                    <option value="WEBSERVICE" v-if="entitiesType != 'decentralised'" class="color-black-message-details" > {{ $t('common.routing.web_service') }} </option>
                    <option value="FTP" v-if="entitiesType != 'decentralised'" class="color-black-message-details" > {{ $t('common.routing.ftp') }} </option>
                    <option value="S3"v-if="entitiesType == 'decentralised'"  class="color-black-message-details" > {{ $t('common.routing.s3') }} </option>
                    <option v-if="entityType == 2"  value="DATABASE" class="color-black-message-details" > {{ $t('common.routing.database') }} </option>
                  </select>
                </b-col>

                <b-col sm="6" class="form-group" v-if="isMQSeries(config) && key == '1' && entitiesType != 'decentralised' && entityType != '0'">
                  <label v-if="key == '1' && entityType == '2'" for="config-mq">
                    {{ $t('common.routing.config_name_connector') }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <label v-else for="config-mq">
                    {{ $t('common.routing.config_name') }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <select class="form-control" v-model="config.configMQSeriesId" readonly
                    id="config-mq"
                    :class="selectMQSeriesColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in mqseriesListSender" :key="index" :value="item.IdConfigRouting" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-else-if="isMQSeries(config) && key == '0' && entitiesType != 'decentralised' && entityType != '2'">
                  <label v-if="key == '0' && entityType == '0'" for="config-mq">
                    {{ $t('common.routing.config_name_connector') }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <label v-else for="config-mq">
                    {{ $t('common.routing.config_name_'+key) }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <select class="form-control" v-model="config.configMQSeriesId" readonly
                    id="config-mq"
                    :class="selectMQSeriesColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in mqseriesListReceiver" :key="index" :value="item.IdConfigRouting" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-if="isWebService(config) && key == '1' && entityType != '0'">
                  <label v-if="key == '1' && entityType == '2'" for="config-web">
                    {{ $t('common.routing.config_name_connector') }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <label v-else for="config-web">
                    {{ $t('common.routing.config_name_'+key) }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <select class="form-control" v-model="config.configWebServiceId" readonly
                    id="config-web"
                    :class="selectWebServiceColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in webServiceListSender" :key="index" :value="item.IdWebService" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-else-if="isWebService(config) && key == '0' && entitiesType != 'decentralised' && entityType != '2'">
                  <label v-if="key == '0' && entityType == '0'" for="config-web">
                    {{ $t('common.routing.config_name_connector') }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <label v-else for="config-web">
                    {{ $t('common.routing.config_name_'+key) }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <select class="form-control" v-model="config.configWebServiceId" readonly
                    id="config-web"
                    :class="selectWebServiceColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in webServiceListReceiver" :key="index" :value="item.IdWebService" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-if="isFTP(config) && key == '1' && entityType != '0'">
                  <label v-if="key == '1' && entityType == '2'" for="config-ftp">
                    {{ $t('common.routing.config_name_connector') }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <label v-else for="config-ftp">
                    {{ $t('common.routing.config_name_'+key) }}<span class="color-red"> * </span>
                  </label>
                  <select class="form-control" v-model="config.configFTPId" readonly
                    id="config-ftp"
                    :class="selectFTPColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in ftpListSender" :key="index" :value="item.IdFTP" >{{item.Name}}</option>
                  </select>
                </b-col>
                <b-col sm="6" class="form-group" v-else-if="isFTP(config) && key == '0' && entitiesType != 'decentralised' && entityType != '2'">
                  <label v-if="key == '0' && entityType == '0'" for="config-ftp">
                    {{ $t('common.routing.config_name_connector') }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <label v-else for="config-ftp">
                    {{ $t('common.routing.config_name_'+key) }}
  <!--                  <span class="color-red"> * </span>-->
                  </label>
                  <select class="form-control" v-model="config.configFTPId" readonly
                    id="config-ftp"
                    :class="selectFTPColor"
                    :disabled="mode === 'details' && editMode === false">
                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>
                    <option class="color-black-message-details" v-for="(item, index) in ftpListReceiver" :key="index" :value="item.IdFTP" >{{item.Name}}</option>
                  </select>
                </b-col>
<!--                <b-col sm="6" class="form-group" v-else-if="isS3(config) && key == '1' && entityType == '1' && entitiesType == 'decentralised'">-->
<!--                  <label v-if="key == '1' && entityType == '1'" for="config-web">-->
<!--                    {{ $t('common.routing.config_name_connector') }}-->
<!--                    &lt;!&ndash;                  <span class="color-red"> * </span>&ndash;&gt;-->
<!--                  </label>-->
<!--                  <label v-else for="config-web">-->
<!--                    {{ $t('common.routing.config_name_'+key) }}-->
<!--                    &lt;!&ndash;                  <span class="color-red"> * </span>&ndash;&gt;-->
<!--                  </label>-->
<!--                  <select class="form-control" v-model="config.configS3Id" readonly-->
<!--                          id="config-web"-->
<!--                          :class="selectS3Color"-->
<!--                          :disabled="mode === 'details' && editMode === false">-->
<!--                    <option value="null" disabled hidden> {{ $t('common.routing.select_config') }} </option>-->
<!--                    <option class="color-black-message-details" v-for="(item, index) in S3ListReceiver" :key="index" :value="item.IdConfigS3" >{{item.ConfigName}}</option>-->
<!--                  </select>-->
<!--                </b-col>-->
<!--                <b-col sm="6" class="form-group" v-if="entityType == '0' && key == 0 && arrayConfig[1].configType == 'WEBSERVICE' && connectorHeaderExist()">-->
<!--                  <label for="routing-auth">-->
<!--                    {{ $t('common.routing.authentification') }}-->
<!--  &lt;!&ndash;                  <span class="color-red"> * </span>&ndash;&gt;-->
<!--                  </label>-->
<!--                  <select class="form-control" disabled id="routing-auth">-->
<!--                    <option value="null" selected > {{ $t('common.routing.JWT') }} </option>-->
<!--                  </select>-->
<!--                </b-col>-->
  <!--              <b-col sm="5"></b-col>-->
  <!--              <b-col sm="5"></b-col>-->
  <!--              <b-col sm="2">-->
  <!--                <button v-if="(editMode|| mode == 'create') && arrayConfig.length > 1" class="btn w-auto px-4 btn-tertiary" @click="removeConfig(key, config.IdMessageRouting)">{{ $t('common.security.remove_certificat') }}</button>-->
  <!--              </b-col>-->
              </b-row>

            </form-accordion>
          </b-col>
          <b-col sm="12" v-if="OldCertIdentifier != '' && entityType == '0'">
            <form-accordion :title="$t('common.routing.authentification_certification')" :isTitleUpperCase="false">
              <b-row>
                <b-col sm="6" class="form-group">
                  <form-write-group-label-input v-model="CertIdentifier" isMandatory :disabled="mode === 'details' && editMode === false"
                    :inputLabel="$t('common.routing.certificat_identifier')" :placeholderValue="$t('common.routing.certificat_identifier')">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </form-accordion>
          </b-col>
<!--          <b-col sm="12" v-if="entityType == '0'  && connectorHeaderExist()">-->
<!--            <form-accordion :title="$t('common.routing.authentification_header')" :isTitleUpperCase="false">-->
<!--              <b-row>-->
<!--                <b-col sm="6" class="form-group">-->
<!--                  <form-write-group-label-input v-model="HeaderValue" isMandatory :disabled="mode === 'details' && editMode === false"-->
<!--                    :inputLabel="$t('common.routing.authentification_header_value')" :placeholderValue="$t('common.routing.authentification_header_value')">-->
<!--                  </form-write-group-label-input>-->
<!--                </b-col>-->
<!--              </b-row>-->
<!--            </form-accordion>-->
<!--          </b-col>-->
          <b-col sm="6" class="form-group" >
            <label for="config-type">
              {{ $t('common.routing.config_active') }}
              <span class="color-red"> * </span>
            </label>
            <select class="form-control" v-model="active" readonly
                    id="config-type-active"
                    :class="selectTypeColor"
                    :disabled="mode === 'details' && editMode === false">
              <option value="null" hidden disabled> {{ $t('common.routing.select_active') }} </option>
              <option value="1" class="color-black-message-details"> {{ $t('common.routing.active') }} </option>
              <option value="0" class="color-black-message-details"> {{ $t('common.routing.desactivate') }} </option>
            </select>
          </b-col>
        </b-row>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="(mode === 'create' && demo) && formHasErrorWithoutAlert()">
            <b-button variant="primary"
              @click="createMessageRouting">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-else-if="(mode === 'create' && demo) && !formHasErrorWithoutAlert()">
            <b-button disabled variant="primary">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canEditMessage && demo">
            <b-button variant="primary"
              @click="editModeActivate">
              <i class="fa-light fa-pencil"></i>
              <span>{{$t('administration.edit')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'details' && editMode === false && canDeleteMessage && demo">
            <b-button variant="primary"
              @click="deleteMessageRouting">
              <i class="fa-light fa-trash"></i>
              <span>{{$t('rights.delete')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="(mode === 'details' && editMode === true && demo) && formHasErrorWithoutAlert()">
            <b-button variant="primary"
              @click="editMessageRouting">
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.sve') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-else-if="(mode === 'details' && editMode === true && demo) && !formHasErrorWithoutAlert()">
            <b-button disabled variant="primary">
              <i class="fa-light fa-save"></i>
              <span>{{ $t('common.sve') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"

import {loadPage} from '@/helpers/routing'
import FormAccordion from "@/components/common/FormAccordion.vue";
import {elements} from "canvg";

export default {
  name: 'MessageDetails',
  components: {
    FormAccordion,
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    role: {
      type: String,
      default: "0"
    },
    type: {
      type: String,
      default: "0"
    },
    entitiesType: {
    },
    tabName: {
    }
  },
  computed: {
    sliderColorClass () {
      return 'RTP-slider'
    },
    statusDisplay () {
      let realCorporateIdentifierType = Object.values(this.corporateIdentifierType).filter(status => status.state === 1)
      if (realCorporateIdentifierType.length === 0) {
        return {
          label: this.$t('filter.selected_corporate_identifier_type_none'),
          nb: 0
        }
      } else if (realCorporateIdentifierType.length === 1) {
        return {
          label: realCorporateIdentifierType[0].label,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_corporate_identifier_type_many', {nbStatus: realCorporateIdentifierType.length}),
        }
      }
    },
    canDeleteMessage () {
      return this.$engine.rights.rightIs('messageRoutingConfig_delete', true)
    },
    canEditMessage () {
      return this.$engine.rights.rightIs('messageRoutingConfig_edit', true)
    },
    configId () {
      switch (this.configType) {
        case 'INTERPROCESS':
          return this.configInterProcessId
        case 'MQSERIES':
          return this.configMQSeriesId
        case 'REMOTEFOLDER':
          return this.configRemoteFolderId
        case 'FTP':
          return this.configFTPId
        case 'S3':
          return this.configS3Id
        default:
          return this.configWebServiceId
      }
    },
    pageTitle () {
      return this.mode === 'details' ? this.$t('Webheader.message_details') : this.$t('Webheader.message_add')
    },
    selectFormatColor () {
      return this.idFormat === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectInterProcessColor () {
      return this.configInterProcessId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectMQSeriesColor () {
      return this.configMQSeriesId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectRemoteFolderColor () {
      return this.configRemoteFolderId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectTypeColor () {
      return this.configType === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectWebServiceColor () {
      return this.configWebServiceId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectS3Color () {
      return this.configS3Id === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
    selectFTPColor () {
      return this.configWebServiceId === 'null' ? 'color-black-message-details-80' : 'color-black-message-details'
    },
  },
  data () {
    return {
      acceptableErrorThreshold: 101,
      selectNull0: false,
      selectNull1: false,
      activateSpinner: false,
      corporateIdentifierType: {
        BANK: {
          label: this.$t('tracking.select.identifiers.BANK.label'),
          value: 1,
          state: 0
        },
        CBID: {
          label: this.$t('tracking.select.identifiers.CBID.label'),
          value: 2,
          state: 0
        },
        CHID: {
          label: this.$t('tracking.select.identifiers.CHID.label'),
          value: 3,
          state: 0
        },
        CINC: {
          label: this.$t('tracking.select.identifiers.CINC.label'),
          value: 4,
          state: 0
        },
        COID: {
          label: this.$t('tracking.select.identifiers.COID.label'),
          value: 5,
          state: 0
        },
        CUST: {
          label: this.$t('tracking.select.identifiers.CUST.label'),
          value: 6,
          state: 0
        },
        DUNS: {
          label: this.$t('tracking.select.identifiers.DUNS.label'),
          value: 7,
          state: 0
        },
        EMPL: {
          label: this.$t('tracking.select.identifiers.EMPL.label'),
          value: 8,
          state: 0
        },
        GS1G: {
          label: this.$t('tracking.select.identifiers.GS1G.label'),
          value: 9,
          state: 0
        },
        SREN: {
          label: this.$t('tracking.select.identifiers.SREN.label'),
          value: 10,
          state: 0
        },
        SRET: {
          label: this.$t('tracking.select.identifiers.SRET.label'),
          value: 11,
          state: 0
        },
        TXID: {
          label: this.$t('tracking.select.identifiers.TXID.label'),
          value: 12,
          state: 0
        },
        BDID: {
          label: this.$t('tracking.select.identifiers.BDID.label'),
          value: 13,
          state: 0
        },
        BOID: {
          label: this.$t('tracking.select.identifiers.BOID.label'),
          value: 14,
          state: 0
        },
        LEIC: {
          label: this.$t('tracking.select.identifiers.LEIC.label'),
          value: 15,
          state: 0
        },
        EUID: {
          label: this.$t('tracking.select.identifiers.EUID.label'),
          value: 16,
          state: 0
        }
      },
      arrayConfig: [{
        configInterProcessId: '',
        configMQSeriesId: '',
        configFTPId: '',
        configRemoteFolderId: '',
        configType: 'WEBSERVICE',
        configWebServiceId: '',
        configS3Id: '',
      },
      {
        configInterProcessId: '',
        configMQSeriesId: '',
        configFTPId: '',
        configRemoteFolderId: '',
        configType: 'WEBSERVICE',
        configWebServiceId: '',
        configS3Id: '',
      }],
      editMode: false,
      idFormat: 'null',
      idStandard: 'null',
      formatList: [],
      interProcessList: [],
      bicGroupList: [],
      BIC: '',
      IdBICGroup: '',
      message: '',
      receiverType: 0,
      demo: true,
      routingName: '',
      active: '',
      CertIdentifier: '',
      OldCertIdentifier: '',
      HeaderValue: '',
      IdAccountSelected: '',
      OldHeaderValue: '',
      routingDescription: '',
      IdMessageRouting: '',
      mqseriesListSender: [],
      mqseriesListReceiver: [],
      webServiceListSender: [],
      webServiceListReceiver: [],
      S3ListSender: [],
      S3ListReceiver: [],
      ftpListSender: [],
      ftpListReceiver: [],
      rightsProfile: [],
      receiverId: '',
      memberId: '',
      remoteFolderList: [],
      returnUrl: '',
      entityType: '',
      savedMessage: [],
      arrayIdMessageRouting: [],
      standardList: [{
        IdStandard: 1,
        Name: 'SRTP'
      }, {
        IdStandard: 2,
        Name: 'HRTP'
      }],
      data: {
        sender: {
          mqseries: [],
          webservice: [],
          S3: [],
          interprocess: [],
          remotefolder: []
        },

        receiver: {
          mqseries: [],
          webservice: [],
          S3: [],
          interprocess: [],
          remotefolder: []
        }
      },
      roleSelected: 0,
      typeSelected: 0,
    }
  },
  created () {
    this.getUrl()
    this.roleSelected = this.role
    this.typeSelected = this.type
    if(this.entitiesType == 'requester'){
      this.typeSelected = 0
      this.roleSelected = 1
    }
    if(this.entitiesType == 'responder'){
      this.typeSelected = 1
      this.roleSelected = 0
    }


    this.roleSelected = this.role
    this.typeSelected = this.type
    if(this.entitiesType == 'decentralised'){
      this.roleSelected = 0
      this.getS3Configs()
    }
    this.getBicGroup()
    this.activateSpinner = true

    // this.getFormat()

    if (this.mode === 'details') {
      this.savedMessage = this.$engine.routing.message.clickedMessage
      this.fillFields()
      this.$engine.routing.message.clickedMessage = {}
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false

    if (this.entityType == 2){
      if (this.arrayConfig[0].configType === 'DATABASE' || this.arrayConfig[1].configType === 'DATABASE'){
        this.arrayConfig[0].configType = 'DATABASE'
        this.arrayConfig[1].configType = 'DATABASE'
      }
    }

    if(this.mode == 'create'){
      this.active = "1"
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
    roleSelected(){
      this.getMQSeriesConfigs()
      this.getWebServiceConfigs()
      this.getS3Configs()
      this.getRightsProfile()
      // this.getFTPConfigs()
      this.selectRole()
    }
  },
  methods: {
    resetConfig (config) {
      config.configFTPId = ""
      config.configMQSeriesId = ""
      config.configInterProcessId = ""
      config.configRemoteFolderId = ""
      config.configWebServiceId = ""
    },
    isInterProcess (config) {
      return config.configType === 'INTERPROCESS'
    },
    isMQSeries (config) {
      return config.configType === 'MQSERIES'
    },
    isRemoteFolder (config) {
      return config.configType === 'REMOTEFOLDER'
    },
    isWebService (config) {
      return config.configType === 'WEBSERVICE'
    },
    isS3 (config) {
      return config.configType === 'S3'
    },
    isFTP (config) {
      return config.configType === 'FTP'
    },
    addCertificat (){
      this.arrayConfig.push({
        configInterProcessId: 'null',
        configMQSeriesId: 'null',
        configFTPId: 'null',
        configRemoteFolderId: 'null',
        configType: 'null',
        configWebServiceId: 'null',
      })
    },
    removeConfig (key, IdMessageRouting) {

      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.message_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdMessageRouting: IdMessageRouting
              }

              that.arrayConfig.splice(key , 1)
              that.arrayIdMessageRouting.splice(key , 1)

              that.$engine.routing.message.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.message_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    selectRole () {
      if (this.entitiesType === 'rvm'){
        if(this.roleSelected == 0){
          this.typeSelected = 0
        }
        if(this.roleSelected == 1){
          this.typeSelected = 1
        }
      }

      this.mqseriesListSender = this.data.sender.mqseries
      this.mqseriesListReceiver = this.data.receiver.mqseries
      this.webServiceListSender = this.data.sender.webservice
      this.webServiceListReceiver = this.data.receiver.webservice
      this.S3ListSender = this.data.sender.S3
      this.S3ListReceiver = this.data.receiver.S3
      this.ftpListSender = this.data.sender.ftp
      this.ftpListReceiver = this.data.receiver.ftp
    },
    createMessageRouting () {
      let that = this


      if (this.entityType == 2){
        if (this.arrayConfig[0].configType === 'DATABASE' || this.arrayConfig[1].configType === 'DATABASE'){
          this.arrayConfig[0].configType = 'DATABASE'
          this.arrayConfig[1].configType = 'DATABASE'
        }
      }

      if (this.formHasError()) {
        return
      }

      let configType

      if (this.entityType == 0){
        configType = this.arrayConfig[0].configType
      }

      if (this.entityType == 1){
        configType = this.arrayConfig[1].configType
      }

      if (this.entityType == 2){
        configType = this.arrayConfig[1].configType
      }

      if (this.entityType == 1 && this.entitiesType == 'decentralised'){
        configType = this.arrayConfig[1].configType
      }

      let params = {
        IdAccountSelected: this.IdAccountSelected,
        Type: this.typeSelected,
        Role: this.roleSelected,
        Name: this.routingName,
        Active: this.active,
        CertIdentifier: this.CertIdentifier,
        HeaderValue: this.HeaderValue,
        Description: this.routingDescription,
        ReceiverId: this.receiverId,
        MemberId: this.memberId,
        AcceptableErrorThreshold: this.acceptableErrorThreshold,
        RoutingType: configType,
        BIC: this.BIC,
        IdBICGroup: this.IdBICGroup,
        entityType: this.entityType,
        CorporateIdentifierType: Object.values(this.corporateIdentifierType)
            .filter(status => status.state === 1)
            .map(item => item.value)
            .join(';')
      }

      if (this.arrayConfig.entitiesType !== 'rvm'){
        params.Type = this.type
        params.Role = this.role
      }



      switch (configType) {
        case 'INTERPROCESS':
          params.IdConfigInput = this.arrayConfig[0].configInterProcessId
          params.IdConfigOutput = this.arrayConfig[1].configInterProcessId
          break
        case 'MQSERIES':
          params.IdConfigInput = this.arrayConfig[0].configMQSeriesId
          params.IdConfigOutput = this.arrayConfig[1].configMQSeriesId
          break
        case 'REMOTEFOLDER':
          params.IdConfigInput = this.arrayConfig[0].configRemoteFolderId
          params.IdConfigOutput = this.arrayConfig[1].configRemoteFolderId
          break
        case 'WEBSERVICE':
          params.IdConfigInput = this.arrayConfig[0].configWebServiceId
          params.IdConfigOutput = this.arrayConfig[1].configWebServiceId
          break
        case 'S3':
          params.IdConfigOutput = this.arrayConfig[1].configS3Id
          break
        default:
          break
      }

      this.$engine.routing.message.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.message_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return loadPage(that, {url: that.returnUrl})
              }
            }
          ]
        })
      })
      .catch(e => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "ReceiverId Exist") {
              that.okMessageBox(that.$t('common.routing.receiver_id_exist'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
          that.okMessageBox(that.$t('common.routing.message_addition_error'))
        }
      })
    },
    deleteMessageRouting () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.message_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdMessageRouting: that.savedMessage.IdMessageRouting
              }

              if (IdMessageRouting){
                params.IdMessageRouting = IdMessageRouting
              }
              that.$engine.routing.message.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.message_deleted'))
                loadPage(that, {url: this.returnUrl})
              })
              .catch(error => {
                errorMessageAlert(error, that)
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editMessageRouting () {
      this.editRouting()
    },
    editRouting () {
      let that = this

      let flag = true
      if (this.role != 0 || this.type != 1) {
        if (this.configType === 'DATABASE') {
          this.configType = 'null'
        }
      }

      let configType

      if (this.entityType == 0){
        configType = this.arrayConfig[0].configType
      }

      if (this.entityType == 1){
        configType = this.arrayConfig[1].configType
      }

      if (this.entityType == 2){
        configType = this.arrayConfig[1].configType
      }

      if (this.entityType == 1 && this.entitiesType == 'decentralised'){
        configType = this.arrayConfig[1].configType
      }
      if (this.formHasError()) {
        return
      }

      let params = {
        IdAccountSelected: this.IdAccountSelected,
        Role: this.roleSelected,
        Type: this.typeSelected,
        // Message: this.message,
        ReceiverId: this.receiverId,
        MemberId: this.memberId,
        AcceptableErrorThreshold: this.acceptableErrorThreshold,
        RoutingName: this.routingName,
        Active: this.active,
        CertIdentifier: this.CertIdentifier,
        HeaderValue: this.HeaderValue,
        RoutingDescription: this.routingDescription,
        // IdFormat: this.idFormat,
        IdConfig: this.configId,
        RoutingType: configType,
        IdMessageRouting: this.arrayConfig[0].IdMessageRouting != '' ? this.arrayConfig[0].IdMessageRouting: this.arrayConfig[1].IdMessageRouting,
        IdBICGroup: this.IdBICGroup,
        entityType: this.entityType,
        CorporateIdentifierType: Object.values(this.corporateIdentifierType)
            .filter(status => status.state === 1)
            .map(item => item.value)
            .join(';')
        // Standard: this.idStandard
      }

      switch (configType) {
        case 'INTERPROCESS':
          params.IdConfigInput = this.arrayConfig[0].configInterProcessId
          params.IdConfigOutput = this.arrayConfig[1].configInterProcessId
          break
        case 'MQSERIES':
          params.IdConfigInput = this.arrayConfig[0].configMQSeriesId
          params.IdConfigOutput = this.arrayConfig[1].configMQSeriesId
          break
        case 'REMOTEFOLDER':
          params.IdConfigInput = this.arrayConfig[0].configRemoteFolderId
          params.IdConfigOutput = this.arrayConfig[1].configRemoteFolderId
          break
        case 'WEBSERVICE':
          params.IdConfigInput = this.arrayConfig[0].configWebServiceId
          params.IdConfigOutput = this.arrayConfig[1].configWebServiceId
          break
        case 'S3':
          params.IdConfigOutput = this.arrayConfig[1].configS3Id
          break
        default:
          break
      }

      this.$engine.routing.message.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.message_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: that.returnUrl})
      })
      .catch(e => {
        flag = false
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.message_edition_error'))
      })

    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.role = this.savedMessage.Role
      this.BIC = this.savedMessage.ReceiverId
      this.IdBICGroup = this.savedMessage.IdBICGroup
      this.type = this.savedMessage.Type !== undefined ? this.savedMessage.Type : this.type
      this.message = this.savedMessage.Message
      this.receiverId = this.savedMessage.ReceiverId
      this.memberId = this.savedMessage.MemberId
      this.acceptableErrorThreshold = this.savedMessage.AcceptableErrorThreshold
      this.idFormat = this.savedMessage.IdFormat
      this.configType = this.savedMessage.ConfigType
      this.routingName = this.savedMessage.RoutingName
      this.active = this.savedMessage.Active
      this.CertIdentifier = this.savedMessage.CertIdentifier
      this.OldCertIdentifier = this.savedMessage.CertIdentifier
      this.IdAccountSelected = this.savedMessage.IdAccount
      this.OldHeaderValue = this.savedMessage.HeaderValue
      this.HeaderValue = this.savedMessage.HeaderValue
      this.routingDescription = this.savedMessage.RoutingDescription
      this.arrayIdMessageRouting = []

      if(this.savedMessage.CorporateIdentifierType != undefined){
        for (let corporateIdentifierTypeKey in this.corporateIdentifierType) {
          if (this.savedMessage.CorporateIdentifierType.find((element) => element == this.corporateIdentifierType[corporateIdentifierTypeKey].value)) {
            this.corporateIdentifierType[corporateIdentifierTypeKey].state = 1
          }
        }
      }

      let array = []
      this.savedMessage.Configs.forEach(element => {
        let item = {
          configType: element.ConfigType,
          IdMessageRouting :element.IdMessageRouting
        }

        switch (element.ConfigType) {
          case 'INTERPROCESS':
            item.configInterProcessId = element.IdConfig
            break
          case 'MQSERIES':
           item.configMQSeriesId = element.IdConfig
            break
          case 'REMOTEFOLDER':
           item.configRemoteFolderId = element.IdConfig
            break
          case 'WEBSERVICE':
           item.configWebServiceId = element.IdConfig
            break
          case 'S3':
           item.configS3Id = element.IdConfig
            break
          case 'FTP':
            item.configFTPId = element.IdConfig
            break
          default:
            break
        }
        array.push(item)
        this.arrayIdMessageRouting.push(element.IdMessageRouting)
      })
      this.arrayConfig = array

      // if (this.configType === "INTERPROCESS") {
      //   this.getInterProcessConfigs()
      //   this.configInterProcessId = this.savedMessage.IdConfig
      // }
      // if (this.configType === "MQSERIES") {
      //   this.getMQSeriesConfigs()
      //   this.configMQSeriesId = this.savedMessage.IdConfig
      // }
      // if (this.configType === "REMOTEFOLDER") {
      //   this.getRemoteFolderConfigs()
      //   this.configRemoteFolderId = this.savedMessage.IdConfig
      // }
      // if (this.configType === "WEBSERVICE") {
      //   this.getWebServiceConfigs()
      //   this.configWebServiceId = this.savedMessage.IdConfig
      // }
      // if (this.configType === "FTP") {
      //   this.getFTPConfigs()
      //   this.configFTPId = this.savedMessage.IdConfig
      // }

      this.selectRole()
    },
    formHasError () {
      if (this.entitiesType != 'decentralised'){
        // if(this.connectorHeaderExist()){
        //   if (this.HeaderValue.length === 0 && this.entityType == 0) {
        //     this.okMessageBox(this.$t('common.routing.header_value_missing'))
        //     return true
        //   }
        // }
      }
      if (this.receiverId.length === 0) {
        this.okMessageBox(this.$t('common.routing.receiver_id_missing'))
        return true
      }
      if (this.IdAccountSelected.length === 0 && this.entitiesType != 'decentralised' && this.entityType !== 1) {
        this.okMessageBox(this.$t('common.routing.id_account_missing'))
        return true
      }
      if (this.routingName.length === 0) {
        this.okMessageBox(this.$t('common.routing.receiver_routing_name'))
        return true
      }
      if (this.active == '') {
        this.okMessageBox(this.$t('common.routing.routing_active_missing'))
        return true
      }
      if (this.OldCertIdentifier.length !== 0 && this.CertIdentifier.length === 0) {
        this.okMessageBox(this.$t('common.routing.certificat_identifier_missing'))
        return true
      }
      if (this.entitiesType === 'rvm') {
        if (this.arrayConfig[0].configType !== "NULL" && this.arrayConfig[0].configType !== this.arrayConfig[1].configType) {
          this.okMessageBox(this.$t('common.routing.config_type_same'))
          return true
        }
      }
      let missingType = true
      let missingName = true
      let hasInvalidElement = false
      this.arrayConfig.some(element => {
        if (element.configType !== "null") {
          missingType = false
        }

        if (
            ((element.configWebServiceId !== '' ||
                    element.configMQSeriesId !== '' ||
                    element.configS3Id !== '' ||
                    element.configFTPId !== '') &&
                element.configType !== 'DATABASE') || element.configType === 'DATABASE'
        ) {
          missingName = false
        } else if (element.configType === 'NULL') {
          missingName = false
        }
      })
      if (missingType) {
        this.okMessageBox(this.$t('common.routing.config_type_missing'))
      }
      if (missingName) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
      }
      hasInvalidElement = missingType || missingName
      if (hasInvalidElement) {
        return false
      }
      if (this.entitiesType === 'decentralised' && this.acceptableErrorThreshold === 0) {
        this.okMessageBox(this.$t('common.routing.acceptable_error_threshold_missing'))
        return true
      }
      return false
    },
    connectorHeaderExist(){
      if(this.arrayConfig[0].configWebServiceId != '' && this.arrayConfig[0].configType == "WEBSERVICE"){
        let connectorSelected = this.webServiceListReceiver.find((element) => this.arrayConfig[0].configWebServiceId == element.IdWebService)
        if (connectorSelected){
          return true
        }
      }
      if(this.arrayConfig[1].configType == "S3"){
        let connectorSelected = this.S3ListReceiver.find((element) => this.arrayConfig[1].configS3Id == element.IdS3)
        if (connectorSelected){
          return true
        }
      }
      if(this.arrayConfig[0].configMQSeriesId != '' && this.arrayConfig[0].configType == "MQSERIES"){
        let connectorSelected = this.mqseriesListReceiver.find((element) => this.arrayConfig[0].configMQSeriesId == element.IdMQSeries)
        if (connectorSelected){
          return true
        }
      }
      return false
    },
    formHasErrorWithoutAlert () {
      if (this.entitiesType != 'decentralised') {
        // if(this.connectorHeaderExist()){
        // }
      }
      if (!this.receiverId || this.receiverId.length === 0) {
        return false
      }
      if ((!this.IdAccountSelected || this.IdAccountSelected.length === 0)&& this.entityType != 1) {
        return false
      }
      if (!this.routingName || this.routingName.length === 0) {
        return false
      }
      if (this.active == '') {
        return false
      }
      if (this.entitiesType === 'rvm') {
        if (this.arrayConfig[0].configType !== "NULL" && this.arrayConfig[0].configType !== this.arrayConfig[1].configType) {
          this.okMessageBox(this.$t('common.routing.config_type_same'))
          return true
        }
      }
      let missingType = true
      let missingName = true
      let hasInvalidElement = false
      this.arrayConfig.some(element => {
        if (element.configType !== 'null') {
          missingType = false
        }

        if (
            ((element.configWebServiceId !== '' && element.configType == 'WEBSERVICE') ||
                    (element.configS3Id !== '' && element.configType == 'S3') ||
                    (element.configMQSeriesId !== '' && element.configType == 'MQSERIES') ||
                    (element.configFTPId !== '' && element.configType == 'FTP') &&
                element.configType !== 'DATABASE') || element.configType === 'DATABASE'
        ) {
          missingName = false
        } else if (element.configType === 'NULL') {
          missingName = false
        }
      })

      hasInvalidElement = missingType || missingName
      if (hasInvalidElement) {
        return false
      }
      if (this.entitiesType === 'decentralised' && this.acceptableErrorThreshold === 0) {
        this.okMessageBox(this.$t('common.routing.acceptable_error_threshold_missing'))
        return true
      }

      return true
    },
    getFormat () {
      let that = this
      this.$engine.routing.format.fetch({
      })
      .then(resp => {
        this.formatList = resp.data.Formats

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getBicGroup () {
      let that = this
      this.$engine.bic.bicGroup.fetch({
      })
      .then(resp => {
        this.bicGroupList = resp.data.BicGroup
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getInterProcessConfigs () {
      let that = this
      this.$engine.routing.config.interProcess.fetch({
      })
      .then(resp => {
        this.interProcessList = resp.data.InterProcesses

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getMQSeriesConfigs () {
      let params = ''
      let that = this
      if (this.entitiesType !== 'rvm') {
        params = {entityType : this.entityType}
      } else {
        params = {entityType : this.entityType}
      }
      this.$engine.routing.config.mqseries.fetch(
        params
      )
      .then(resp => {
        this.data.sender.mqseries = resp.data.MQSeriesConfig
        this.data.receiver.mqseries = resp.data.MQSeriesCredential

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getRemoteFolderConfigs () {
      let that = this
      this.$engine.routing.config.remoteFolder.fetch({
      })
      .then(resp => {
        this.remoteFolderList = resp.data.RemoteFolder

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getWebServiceConfigs () {
      let params = ''
      let that = this
      if (this.entitiesType !== 'rvm') {
        params = { entityType : this.entityType }
      } else {
        params = { entityType : this.entityType }
      }
      this.$engine.routing.config.webService.fetch(
        params
      )
      .then(resp => {
        this.data.sender.webservice = resp.data.WebServiceConfig
        this.data.receiver.webservice = resp.data.WebServiceCredentials

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getS3Configs () {
      let  params = { entityType : 1, messageType:2, role: 0 }
      let that = this
      // if (this.entitiesType !== 'rvm') {
      //   params = { entityType : this.entityType }
      // } else {
      //   params = { entityType : this.entityType }
      // }
      this.$engine.routing.config.s3.fetch(
        params
      )
      .then(resp => {
        this.data.sender.S3 = resp.data.S3Config
        this.data.receiver.S3 = resp.data.S3Config

        this.arrayConfig[1].configS3Id = resp.data.S3Config[0].IdConfigS3
        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        // errorMessageAlert(error, that)
      })
    },
    getFTPConfigs () {
      let params = ''
      let that = this
      if (this.entitiesType !== 'rvm'){
        params = { Role : this.role, Type : this.type }
      } else {
        params = { Role : this.roleSelected, Type : this.typeSelected }
      }
      this.$engine.routing.config.FTP.fetch({
        params
      })
      .then(resp => {
        this.data.sender.ftp = resp.data.FTPConfig
        this.data.receiver.ftp = resp.data.FTPCredential

        this.selectRole()
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getRightsProfile () {
      let params = ''
      let that = this
      this.$engine.rights.getAllProfilesLight()
      .then(resp => {

        if (!resp || !Array.isArray(resp.profiles)) {
          this.rightsProfile = []
          return
        }

        const groupedList = resp.profiles.reduce((acc, item) => {
          if (!acc.some(obj => obj.idAccount === item.idAccount && obj.accountName === item.accountName)) {
            acc.push({ idAccount: item.idAccount, accountName: item.accountName })
          }
          return acc
        }, [])

        this.rightsProfile = groupedList

        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
    },
    getUrl(){
      if (this.entitiesType === 'rvm'){
        this.entityType = 1
        this.returnUrl = '/entitiessettings/rvm/BICRVM'
      }
      if (this.entitiesType === 'requester'){
        this.entityType = 0
        this.returnUrl = '/entitiessettings/requester/Corporate'
      }
      if (this.entitiesType === 'responder'){
        this.entityType = 2
        this.returnUrl = '/entitiessettings/responder/SI'
      }
      if (this.entitiesType === 'decentralised'){
        this.entityType = 1
        this.returnUrl = '/entitiessettings/decentralised/SI'
        this.arrayConfig[1].configType = 'S3'
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onChangeConfigType () {
      switch (this.configType) {
        case 'INTERPROCESS':
          this.getInterProcessConfigs()
          this.configMQSeriesId = 'null'
          this.configRemoteFolderId = 'null'
          this.configWebServiceId = 'null'
          this.configFTPId = 'null'
          break
        case 'REMOTEFOLDER':
          this.getRemoteFolderConfigs()
          this.configInterProcessId = 'null'
          this.configMQSeriesId = 'null'
          this.configWebServiceId = 'null'
          this.configFTPId = 'null'
          break
        case 'MQSERIES':
          this.configInterProcessId = 'null'
          this.configRemoteFolderId = 'null'
          this.configWebServiceId = 'null'
          this.configFTPId = 'null'
          break
        case 'WEBSERVICE':
          this.configInterProcessId = 'null'
          this.configMQSeriesId = 'null'
          this.configRemoteFolderId = 'null'
          this.configFTPId = 'null'
          break
        case 'FTP':
          this.configInterProcessId = 'null'
          this.configMQSeriesId = 'null'
          this.configRemoteFolderId = 'null'
          this.configWebServiceId = 'null'
          break
      }
      this.selectRole()
    }
  }
}
</script>
